import { useRef, useState } from 'react';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom';
import { ClearLocalStorage, getLocalStoragKey, LocalStorageKEYS, setLocalStorage } from '../../store/mahutiLocalStorage';
import { removeActivity, resetSelections, setOpportunity, setPaymentCountDown } from '../../store/MahutiReducer';
import './MahutiCountDown.css'
import MahutiModal from '../mahuti-modal/MahutiModal';
import { PREFIX_PATH } from '../../utils/GlobalParams';
import { isMobile } from 'react-device-detect';
import { calculateCountDownSeconds, checkTimestemp } from '../../utils/orderUtils';
import ExclamationMark from '../../svg/exclamationMark';

export default function MahutiCountDown(props) {

    const [modalOpen, setModalOpen] = useState(false);
    const dispatch = useDispatch();
    const [seconds, setSeconds] = useState(Math.floor(props.timer % 60));
    const [mins, setMins] = useState(Math.floor(props.timer / 60));
    const [timeCalc, setTimeCalc] = useState(props.timer);
    const store = useSelector(store => store.reducer);
    const navigate = useNavigate();
    const sendToNewPurchase = () => {
        dispatch(resetSelections())
        let lpPrefix = store.lpName ? '/' + store.lpName : '';
        navigate(PREFIX_PATH + lpPrefix + '/');
    }
    
    let finalMount = useRef(true);
    useEffect(() => {
            if(finalMount.current){
                finalMount.current = false
                let counter = 0;
                timerFunc(counter)
            }
        
    }, [])

    const clearCounter = (interval) => {
        clearInterval(interval);
        setModalOpen(true)
        dispatch(removeActivity('*'))
        ClearLocalStorage()
        dispatch(setOpportunity())
    }

    const timerFunc = (counter) => {
        let timerVal = timeCalc
        const interval = setInterval(() => {
            counter++
            const MinsCalcInMin = Math.floor(timerVal / 60);
            setMins(MinsCalcInMin);
            const myseconds = Math.floor(timerVal % 60);
            setSeconds(myseconds);
            if(counter === 2 && !(MinsCalcInMin === 0 && myseconds === 0)){ // check every x sec timestemp gap
                let sec = checkTimestemp(getLocalStoragKey('countDownTimestemp'), false)
                counter = 0;
                if(sec){
                    timerVal = sec
                }else{
                    clearCounter(interval)
                }
            }
            if(MinsCalcInMin === 0 && myseconds === 0) {
                clearCounter(interval)
            }else{
                timerVal--
            }
        }, 1000);
    }

    return <>
            {props.showTimer && <div className={"mahutiCountDown card-title " + (mins === 0 && seconds > 0 ? 'timeout_border': '')}>
                {mins + seconds > 0 ?
                <div className='align-items-baseline d-flex'>
                    {isMobile ? <div>נותרו</div> : <div>הזמן הנותר לשמירת ההזמנה:</div>}
                    <div className="value count_num">{`${('0' + mins).slice(-2)}:${('0' + seconds).slice(-2)}`}</div> 
                    <div className='main-color'>דקות</div>
                </div> : null}
            </div> }
            {modalOpen && <MahutiModal closeModalWhenClickingBg={false} setModalOpen={setModalOpen} >
                <div className="card activityDetailCard border-0 rounded-0">
                    <div className="text-start ps-2 pt-3">
                        <button onClick={() => { setModalOpen(false); sendToNewPurchase() }} className=" btn btn-icon countdown_pop_close_btn">
                            <i className="exit-shape icon-close close"></i>
                        </button>
                    </div>
                    <div className="modal_content text-center d-flex align-items-center justify-content-center flex-column timeout_pop">
                        {/* <div className="alert_icon mb-2"></div> */}
                        <ExclamationMark/>
                        <h4 className='mb-4 almoni_tzar_normal'>זמן הרכישה הסתיים</h4>  
                        <p className='mb-4 pb-2 text-mahuti'>סל הקניות שלך ריק.</p>  
                        <button onClick={sendToNewPurchase} className='btn btn-primary almoni_tzar_light'>לרכישה חדשה</button>
                    </div>   
                </div>
            </MahutiModal>}
        </>
}

